<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 68 68">
    <g>
      <g>
        <path
          d="m66.6 15.2-17.6-14c-.4-.3-.9-.3-1.2 0l-17.6 14c-.3.3-.5.7-.3 1.1.1.4.5.7.9.7h2v13.7h-1.3c-.6 0-1 .4-1 1v4.3c0 .6.4 1 1 1h33.8c.6 0 1-.4 1-1v-4.3c0-.6-.4-1-1-1h-1.3v-13.7h2c.4 0 .8-.3.9-.7.2-.4.1-.8-.3-1.1zm-18.2-11.9 14.7 11.7h-.1c-6 0-23.2 0-29.3 0zm3.3 27.4v-13.7h5.7v13.7zm-12.3 0v-13.7h5.7v13.7zm7.7-13.7h2.6v13.7h-2.6zm-12.3 0h2.6v13.7h-2.6zm29.5 18h-31.8v-2.3h31.8zm-2.3-4.3h-2.6v-13.7h2.6z"
        />
      </g>
      <g>
        <path
          d="m20.3 31.2c-.4-.3-.9-.3-1.2 0l-17.6 14c-.3.3-.5.7-.3 1.1 0 .4.4.7.8.7h2v13.7h-1.3c-.6 0-1 .4-1 1v4.3c0 .6.4 1 1 1h33.8c.6 0 1-.4 1-1v-4.3c0-.6-.4-1-1-1h-1.3v-13.7h2c.4 0 .8-.3.9-.7s0-.8-.3-1.1zm-.7 2.1 14.8 11.7h-.2c-46.9 0 18 0-29.2 0h-.1zm3.3 27.4v-13.7h5.7v13.7zm-12.3 0v-13.7h5.7v13.7zm7.7-13.7h2.6v13.7h-2.6zm-12.3 0h2.6v13.7h-2.6zm29.6 18h-31.9v-2.3h31.8v2.3zm-2.4-4.3h-2.6v-13.7h2.6z"
        />
      </g>
      <g>
        <path
          d="m57.5 39.4c-.2-.2-.5-.4-.8-.4s-.5.1-.7.3l-5.8 6.5c-.4.4-.3 1 .1 1.4s1 .3 1.4-.1l4-4.6v20.2h-14.6c-.6 0-1 .4-1 1s.4 1 1 1h15.7c.6 0 1-.4 1-1v-21l4 4.6c.4.4 1 .5 1.4.1s.5-1 .1-1.4z"
        />
      </g>
      <g>
        <path
          d="m8.6 35.1c.6 0 1-.4 1-1v-23.6h17.2l-4.6 4c-.4.4-.5 1-.1 1.4s1 .5 1.4.1c0 0 6.5-5.8 6.6-5.8.2-.2.3-.5.3-.7 0-.3-.2-.6-.3-.7l-6.6-5.8c-.4-.4-1-.3-1.4.1s-.3 1 .1 1.4l4.6 4h-18.2c-.6 0-1 .4-1 1v24.7c0 .5.4.9 1 .9z"
        />
      </g>
      <g>
        <path
          d="m19.6 43.4c2 0 3.5-1.6 3.5-3.5 0-2-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5zm0-5.1c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5z"
        />
      </g>
      <g>
        <path
          d="m48.4 13.5c2 0 3.5-1.6 3.5-3.5 0-2-1.6-3.5-3.5-3.5s-3.6 1.5-3.6 3.4c0 2 1.6 3.6 3.6 3.6zm0-5.1c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.6-1.5 1.5-1.5z"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "M4BankTransferSvg"
};
</script>
